import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { UnauthInterceptor } from './unauth.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: UnauthInterceptor, multi: true },
];
